import { memo, useMemo, useState, useEffect, useRef } from 'react';
import { useStore } from '@/store';
import { EventCardInfo } from '@/store/types';
// import { getAssetUrl } from '@/utils/common';
import { useTransition, animated, to, SpringValue, useSpring } from '@react-spring/web';
import EventCard, { ShufflePhase } from './components/EventCard';
import styles from './index.module.scss';
import { createPositionGenerator,random } from './generatePosition';
import { useQueryEvents } from '@/services/hooks';
import { CARD_WIDTH, CARD_HEIGHT, CARD_MARGIN, screenWidth, screenHeight, marginLeft, marginTop } from './config';
import { getAssetUrl } from '@/utils/common';
import QrCode from '@/components/QrCode';
import { driveDigitalHumanByText } from '@/pages/DigitalHuman/util/tts-manage';
// import EventPlaceDetail from './components/EventPlaceDetail/index';

// 生成随机缩放
const generateRandomScale = () => random(0.1,2);

// 创建位置生成器
const generateRandomPosition = createPositionGenerator<EventCardInfo>(
  CARD_WIDTH,
  CARD_HEIGHT,
  CARD_MARGIN,
  screenWidth,
  screenHeight
);

interface AnimatedStyle {
  // x: SpringValue<number>;
  // y: SpringValue<number>;
  // rotate: SpringValue<number>;
  // scale: SpringValue<number>;
  opacity: SpringValue<number>;
}


const Event = () => {
  // const setEventCardMode = useStore((state) => state.setEventCardMode);
  const eventCardId = useStore((state) => state.eventCardId);
  const eventDynastyRange = useStore((state) => state.eventDynastyRange);
  const [displayCards, setDisplayCards] = useState<EventCardInfo[]>([]);
  const [shufflePhase, setShufflePhase] = useState<ShufflePhase>('idle');
  const pendingCardsRef = useRef<EventCardInfo[]>([]);
  const { data: oringinData } = useQueryEvents();
  const isFirstRenderRef = useRef(true);

  const [startTime, endTime,startYear,endYear] = eventDynastyRange || [];


  // 每10秒随机选择年份范围
  // useEffect(() => {
  //   if (!oringinData?.length) return;

  //   const interval = setInterval(() => {
  //     const years = oringinData
  //       .map((item: EventCardInfo) => Number(item.year))
  //       .filter((year: number) => !isNaN(year))
  //       .sort((a: number, b: number) => a - b);

  //     if (years.length < 2) return;

  //     const startIndex = Math.floor(Math.random() * (years.length - 1));
  //     const endIndex = Math.floor(Math.random() * (years.length - startIndex - 1)) + startIndex + 1;

  //     setEventCardMode(null, [years[startIndex], years[endIndex]]);
  //   }, 10000);

  //   return () => clearInterval(interval);
  // }, [oringinData]);

  // useEffect(() => {
  //   setTimeout(() => {
  //     setShufflePhase('center');
  //   }, 1000);
  // }, []);


  const data = useMemo(() => {
    if (!oringinData) {
      return []
    }
    // 先按year排序
    const sortedData = [...oringinData].sort((a, b) => {
      const yearA = parseInt(a.year||'0');
      const yearB = parseInt(b.year||'0');
      return yearA - yearB;
    });
    // console.log('start',sortedData.map(item=>item.dynasty));

    if (!startYear && !endYear) return sortedData;




    // 找到开始和结束的索引
    // const startIndex = sortedData.findIndex(item => parseInt(item.year||'0') === parseInt(startYear||'0'));
    // const endIndex = sortedData.findLastIndex(item => parseInt(item.year||'0') === parseInt(endYear||'0'));
    // console.log('startIndex',startIndex,endIndex);

    // // 如果找不到结束年份，则取到最后一个
    // const finalEndIndex = endIndex === -1 ? sortedData.length : endIndex;

    // // 返回筛选后的数据
    // return sortedData.slice(startIndex === -1 ? 0 : startIndex, finalEndIndex);
    return sortedData.filter(item=>{
      const year = parseInt(item.year||'0');
      const startYearInt = parseInt(startYear||'0');
      const endYearInt = parseInt(endYear||'0');
      // 如果只有startYear
      if(startYearInt&&!endYearInt){
        return year>=startYearInt;
      }else if(!startYearInt&&endYearInt){
        return year<=endYearInt;
      }else if(startYearInt&&endYearInt){
        return year>=startYearInt&&year<=endYearInt;
      }
      return false;
    });
  }, [oringinData, startYear, endYear]);


  // console.log('data',eventDynastyRange,data);

  // 随机生成卡片位置和缩放
  const randomCards = useMemo(() => {
    if (!data) {
      return []
    }

    const cards = generateRandomPosition(data);
    return cards.map((card) => {
      return {
        ...card,
        x: card.x + marginLeft,
        y: card.y + marginTop,
        scale: generateRandomScale()
      };
    }).sort((a,b)=>a.scale-b.scale);
  }, [data]);


  // 随机选择卡片
  // const selectRandomCards = (count: number) => {
  //   const shuffled = [...randomCards].sort(() => 0.5 - Math.random());
  //   return shuffled.slice(0, count);
  // };

  // 初始化显示所有卡片
  useEffect(() => {
    // console.log('randomCards',isFirstRenderRef, randomCards);
    if (!randomCards.length) return;
    if (isFirstRenderRef.current) {
      // console.log('randomCards1111',randomCards);
      setDisplayCards(randomCards);
      isFirstRenderRef.current = false;
    } else {
      pendingCardsRef.current = randomCards;
      setShufflePhase('center');
    }
  }, [randomCards]);

  // 语音控制
  useEffect(()=>{
    // if(displayCards.length){
    //   driveDigitalHumanByText('好的，已为您介绍${displayCards.name}，请看详情页。');
    // }
    if(!oringinData) return;
    if(eventCardId){
      const eventCard = oringinData?.find((item: EventCardInfo) => item.entity_id === eventCardId);
      // console.log('eventCard',eventCard);
      if(eventCard){
        driveDigitalHumanByText(`我们现在看到的是${eventCard.name}`);
      }else {
        if(startTime || endTime){
          if(startTime === endTime){
            driveDigitalHumanByText(`未找到${startTime}关于你说的相关文学大事件，是不是在其他时间段`);
          }else if(startTime&&!endTime){
            driveDigitalHumanByText(`未找到${startTime}关于你说的相关文学大事件，是不是在其他时间段`);
          }else if(!startTime&&endTime){
            driveDigitalHumanByText(`未找到${endTime}关于你说的相关文学大事件，是不是在其他时间段`);
          }else{
            driveDigitalHumanByText(`未找到${startTime}到${endTime}关于你说的相关文学大事件，是不是在其他时间段`);
          }
        }else {
          console.warn('未找到相关文学大事件',eventCardId);
          driveDigitalHumanByText('未找到相关文学大事件，你可以选择其他文学大事件');
        }
      }
    }else if(startTime || endTime){
      if(startTime === endTime){
        driveDigitalHumanByText(`我们现在看到的是${startTime}西湖发生的文学大事件`);
      }else {
        if(startTime&&!endTime){
          driveDigitalHumanByText(`我们现在看到的是从${startTime}到现在西湖发生的文学大事件`);
        }else if(!startTime&&endTime){
          driveDigitalHumanByText(`我们现在看到的是从之前到${endTime}西湖发生的文学大事件`);
        }else{
          driveDigitalHumanByText(`我们现在看到的是${startTime}到${endTime}西湖发生的文学大事件`);

        }
      }
    }
  },[oringinData,eventCardId,eventDynastyRange])

  // 防止语音多次播报
  useEffect(()=>{
    if(!eventCardId&&!eventDynastyRange){
      driveDigitalHumanByText('“文学西湖”从百亿+文学数据中精选100+最具代表的西湖文学大事件，以此映照出流动的西湖千年文脉。');
    }
  },[])

  // console.log('displayCards',shufflePhase, displayCards);

  // 使用useTransition控制卡片动画
  const transitions = useTransition<EventCardInfo, AnimatedStyle>(displayCards, {
    from: (item: EventCardInfo) => ({
      // x: item.x,
      // y: item.y,
      // rotate: 0,
      // scale: 0.8,
      opacity: 0,
    }),
    enter: (item: EventCardInfo) => ({
      // x: item.x,
      // y: item.y,
      // rotate: 0,
      // scale: 1,
      opacity: 1,
    }),
    // update: (item: EventCardInfo) => {
    //   switch (shufflePhase) {
    //     case 'center':
    //       case 'shake':
    //       return {
    //         x: centerX - CARD_WIDTH / 2,
    //         y: centerY - CARD_HEIGHT / 2,
    //         rotate: 0,
    //         scale: 1,
    //       };
    //     case 'return':
    //       default:
    //       return {
    //         x: item.x,
    //         y: item.y,
    //         rotate: 0,
    //         scale: 1,
    //       };
    //   }
    // },
    leave: {
      opacity: 0,
      // scale: 0,
    },
    config: {
      // tension: 300,
      // friction: 20,
      duration: 500,
    },
  });

  useEffect(() => {
    let timer: NodeJS.Timeout;
    // console.log('shufflePhase',shufflePhase);
    if (shufflePhase === 'center') {
      timer = setTimeout(() => {
        setShufflePhase('shake');
      }, 500);
    } else if (shufflePhase === 'shake') {
      timer = setTimeout(() => {
        setShufflePhase('return');
        if (pendingCardsRef.current.length > 0) {
          setDisplayCards(pendingCardsRef.current);
          pendingCardsRef.current = [];
        }
      }, 500);
    } else if (shufflePhase === 'return') {
      timer = setTimeout(() => {
        setShufflePhase('idle');
        pendingCardsRef.current = [];
      }, 500);
    }
    return () => clearTimeout(timer);
  }, [shufflePhase]);

  return (
    <>
      <div className={styles.container}>
      <img src={getAssetUrl('images/landmark/mask.png')} alt="" className={styles.mask}/>
        {transitions((style: AnimatedStyle, card: EventCardInfo, _, index: number) => (
          <animated.div
            style={{
              // position: 'absolute',
              ...style,
            }}
          >
            <EventCard
              key={card.entity_id}
              card={card}
              index={index}
              shufflePhase={shufflePhase}
              visible={eventCardId === card.entity_id}
            />
          </animated.div>
        ))}
      </div>
      <QrCode />
      {/* <EventPlaceDetail /> */}
    </>
  );
};

export default memo(Event); 